import gql from 'graphql-tag'

import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation refreshToken {
    refreshToken
  }
`

const transformer = ({ refreshToken }: any) => refreshToken

type variables = any

export default mutationServiceCreator<variables>(mutation, transformer)
